// The browser entry, kept tiny (DESIGN 6.2; LAUNCH_CHECKLIST B36): a first visit to `/` shows the pre-rendered landing
// section of index.html and loads the app bundle (app/boot.tsx) only after Play; every other visit removes the section
// and starts the app at once.

import { ageScreenDone } from './app/ageGate';
import { enterSite, showLanding } from './app/landing';
import { isStandalone } from './platform/displayMode';
import { webStorage } from './platform/storage';
import { loadCloudflareBeacon } from './platform/webAnalytics';

loadCloudflareBeacon(document, location);

const show = showLanding({
  pathname: location.pathname,
  search: location.search,
  returning: ageScreenDone(webStorage(() => globalThis.localStorage)),
  standalone: isStandalone(),
});

enterSite(document, show, () => {
  // first_shot counts from the moment the player asked for the app (DESIGN 5.11).
  const startedAt = performance.timeOrigin + performance.now();
  void import('./app/boot').then((m) => m.boot(startedAt));
});
